import React from 'react'
import { createRoot } from 'react-dom/client'
import PassportApp from './page'
import { initCsrf } from './shared/service/csrfInit'

const root = createRoot(document.getElementById('root'))
const passportAPIServerHost = window.passportAPIServerHost || window.location.origin

initCsrf({
	passportAPIServerHost,
}).finally(() => {
	root.render(<PassportApp />)
})
